import Seo from 'components/seo';
import appData from 'common/data/App/index.json';
import AnalyticsTool from 'containers/App/AnalyticsTool';
import Banner from 'containers/App/Banner';
import Cta from 'containers/App/CTA';
import EverNeed from 'containers/App/EverNeed';
import Faq from 'containers/App/FAQ';
import PricingPolicy from 'containers/App/PricingPolicy';
import Technology from 'containers/App/Technology';
import WalletExperience from 'containers/App/WalletExperience';
import WhyYouChoose from 'containers/App/WhyYouChoose';
import SiteLayout from 'layouts/SiteLayout';
import React from 'react';

const AppCreativeTwo = () => {
  const applicationStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'Furbuz',
    applicationCategory: 'LifestyleApplication',
    operatingSystem: 'Android, iOS',
    description:
      'Pet care tracking, reminders, diet tracking, community, messaging, Lost & Found, local service discovery, and pet care articles.',
    offers: [
      {
        '@type': 'Offer',
        name: 'Furbuz Free',
        price: '0',
        priceCurrency: 'USD',
        description: 'Up to two pets with unlimited care tracking and Connect features, supported by light Connect ads.',
      },
      {
        '@type': 'Offer',
        name: 'Furbuz Pro',
        description:
          'Unlimited pets, no ads, advanced analytics and date ranges, and CSV and PDF reports. Current regional pricing is shown in the app.',
      },
    ],
    featureList: [
      'Pet care tracking and reminders',
      'Diet tracking',
      'Community and messaging',
      'Lost & Found alerts',
      'Local pet service discovery',
      'Advanced analytics and reports with Furbuz Pro',
    ],
  };
  const faqStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: appData.faqs.map((item) => ({
      '@type': 'Question',
      name: item.title,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.description,
      },
    })),
  };
  return (
    <SiteLayout>
      <Seo
        title="Furbuz — Pet care tracker, community, Lost & Found & messaging"
        description="Track pet health, reminders, meals, and progress. Share stories, ask advice, post Lost & Found alerts, find pet services, and message other pet parents — all in Furbuz."
        structuredData={[applicationStructuredData, faqStructuredData]}
      />
      <Banner />
      <WhyYouChoose />
      <AnalyticsTool />
      <EverNeed />
      <WalletExperience />
      <Technology />
      <div className="app_creative_combined_section_wrapper">
        <PricingPolicy className="pricing_policy" />
        <div className="app_creative_dark_section app_creative_section">
          <Faq className="faq_section" />
          <Cta className="cta_section" />
        </div>
      </div>
    </SiteLayout>
  );
};
export default AppCreativeTwo;
